var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	23430: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(74131), __webpack_require__.e(33499), __webpack_require__.e(36715), __webpack_require__.e(91840)]).then(() => (() => (__webpack_require__(91840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	62863: {
		fallback: () => (Promise.all([__webpack_require__.e(90403), __webpack_require__.e(6140)]).then(() => (() => (__webpack_require__(6140))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	303: {
		fallback: () => (Promise.all([__webpack_require__.e(90403), __webpack_require__.e(21137)]).then(() => (() => (__webpack_require__(21137))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	99882: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(25656), __webpack_require__.e(83474)]).then(() => (() => (__webpack_require__(83474))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	40406: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(53022)]).then(() => (() => (__webpack_require__(53022))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	69536: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(99882), __webpack_require__.e(86285), __webpack_require__.e(40709), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(14354))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	5323: {
		fallback: () => (Promise.all([__webpack_require__.e(23430), __webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(76534), __webpack_require__.e(99797)]).then(() => (() => (__webpack_require__(99797))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",
	},
	86285: {
		fallback: () => (Promise.all([__webpack_require__.e(40406), __webpack_require__.e(54800), __webpack_require__.e(74150)]).then(() => (() => (__webpack_require__(74150))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	63880: {
		fallback: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(83273))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/global-environments",
	},
	59868: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(69536), __webpack_require__.e(5323), __webpack_require__.e(86285), __webpack_require__.e(63880), __webpack_require__.e(33713), __webpack_require__.e(76534), __webpack_require__.e(63066), __webpack_require__.e(86745), __webpack_require__.e(74131), __webpack_require__.e(40709), __webpack_require__.e(76204), __webpack_require__.e(25656), __webpack_require__.e(33499), __webpack_require__.e(99737), __webpack_require__.e(52352)]).then(() => (() => (__webpack_require__(52352))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/utils",
	},
	76534: {
		fallback: () => (Promise.all([__webpack_require__.e(74131), __webpack_require__.e(36715), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(45768))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	77638: {
		fallback: () => (Promise.all([__webpack_require__.e(54800), __webpack_require__.e(22157), __webpack_require__.e(96765)]).then(() => (() => (__webpack_require__(96765))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",
	},
	94694: {
		fallback: () => (__webpack_require__.e(56106).then(() => (() => (__webpack_require__(56106))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	2140: {
		fallback: () => (Promise.all([__webpack_require__.e(62863), __webpack_require__.e(303), __webpack_require__.e(99882), __webpack_require__.e(40406), __webpack_require__.e(59463), __webpack_require__.e(59868), __webpack_require__.e(81931), __webpack_require__.e(40028)]).then(() => (() => (__webpack_require__(40028))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/flags",
	},
	20402: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(39775)]).then(() => (() => (__webpack_require__(62156))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/access-control",
	},
	26764: {
		fallback: () => (Promise.all([__webpack_require__.e(31369), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(64948))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/state/route",
	},
	3465: {
		fallback: () => (__webpack_require__.e(9634).then(() => (() => (__webpack_require__(9634))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.2.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",
	},
	60495: {
		fallback: () => (Promise.all([__webpack_require__.e(78064), __webpack_require__.e(36413)]).then(() => (() => (__webpack_require__(36413))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.2.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",
	},
	21672: {
		fallback: () => (Promise.all([__webpack_require__.e(76534), __webpack_require__.e(12473)]).then(() => (() => (__webpack_require__(12473))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular-auth-oidc-client",
	},
	99737: {
		fallback: () => (__webpack_require__.e(98319).then(() => (() => (__webpack_require__(98319))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-device-detector",
	},
	17548: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(86285), __webpack_require__.e(63880), __webpack_require__.e(33713), __webpack_require__.e(59868), __webpack_require__.e(81931), __webpack_require__.e(63066), __webpack_require__.e(83639), __webpack_require__.e(31867), __webpack_require__.e(78064), __webpack_require__.e(54654), __webpack_require__.e(47461), __webpack_require__.e(24485), __webpack_require__.e(63946)]).then(() => (() => (__webpack_require__(63946))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/auth",
	},
	31369: {
		fallback: () => (Promise.all([__webpack_require__.e(23430), __webpack_require__.e(303), __webpack_require__.e(69536), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(24589))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",
	},
	43604: {
		fallback: () => (Promise.all([__webpack_require__.e(99882), __webpack_require__.e(63880), __webpack_require__.e(86745), __webpack_require__.e(54654), __webpack_require__.e(60408), __webpack_require__.e(30874)]).then(() => (() => (__webpack_require__(30874))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/services/common",
	},
	10398: {
		fallback: () => (__webpack_require__.e(7519).then(() => (() => (__webpack_require__(7519))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/webapp/shared/guards",
	},
	36988: {
		fallback: () => (Promise.all([__webpack_require__.e(629), __webpack_require__.e(26945), __webpack_require__.e(68477), __webpack_require__.e(14353), __webpack_require__.e(53118), __webpack_require__.e(64546), __webpack_require__.e(22211), __webpack_require__.e(79846)]).then(() => (() => (__webpack_require__(38693))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@twa/layouts",
	},
	53010: {
		fallback: () => (__webpack_require__.e(99497).then(() => (() => (__webpack_require__(99497))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"303": [
		303
	],
	"2140": [
		2140
	],
	"5323": [
		5323
	],
	"17548": [
		17548
	],
	"23430": [
		23430
	],
	"24485": [
		21672
	],
	"31369": [
		31369
	],
	"40406": [
		40406
	],
	"47461": [
		3465,
		60495
	],
	"59868": [
		59868
	],
	"62358": [
		43604
	],
	"62863": [
		62863
	],
	"62891": [
		20402,
		26764
	],
	"63066": [
		77638,
		94694
	],
	"63880": [
		63880
	],
	"69536": [
		69536
	],
	"76534": [
		76534
	],
	"86285": [
		86285
	],
	"88677": [
		10398,
		36988,
		53010
	],
	"99737": [
		99737
	],
	"99882": [
		99882
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}